import React from 'react';

import { Skeleton } from '@mui/material';
import { useTranslation } from 'react-i18next';

import BdsLabelPill from '../../../../../../shared/components/v3/BdsLabelPill/BdsLabelPill';
import EmptyCard from '../../../../../../shared/components/v3/Cards/EmptyCard/EmptyCard';
import { IMemberFRCycleConsumptions } from '../../../../../../shared/interfaces/collaborators';
import { TRANSLATION_COLLABORATORS } from '../../../../../../shared/translations/collaborators';
import ConsumptionTable from '../ConsumptionTable/ConsumptionTable';

interface ICurrentCycleCard {
  currentCycle: {
    data?: IMemberFRCycleConsumptions;
    loading: boolean;
    error: boolean;
  };
  cycleLabel?: string;
}

const CurrentCycleCard = ({ currentCycle, cycleLabel }: ICurrentCycleCard) => {
  const { t } = useTranslation();
  const { collaboratorBalanceRF } = TRANSLATION_COLLABORATORS.detail;
  const { data, loading } = currentCycle;

  const hasConsumptions = Boolean(data?.hasData) && (data?.total ?? 0) > 0;

  return (
    <>
      <div className="top flex flex-row items-center justify-between w-full">
        <div className="title">{t(collaboratorBalanceRF.currentCycleCard.title)}</div>
        {cycleLabel && <BdsLabelPill text={cycleLabel.toUpperCase()} variant="inactive" />}
      </div>
      {loading && <Skeleton className="collaborator-balance-skeleton" variant="rectangular" height={120} />}
      {!loading && hasConsumptions && data && (
        <ConsumptionTable
          rows={data.consumptions}
          totalExempt={data.totalExempt}
          totalNonExempt={data.totalNonExempt}
          total={data.total}
          currency={data.currency}
        />
      )}
      {!loading && !hasConsumptions && (
        <EmptyCard
          className="collaborator-balance-empty"
          primaryText={t(collaboratorBalanceRF.currentCycleCard.empty.title)}
          secondaryText={t(collaboratorBalanceRF.currentCycleCard.empty.description)}
          center
        />
      )}
    </>
  );
};

export default CurrentCycleCard;
